import { j as f, c as j } from "./utils-BdNIfrGQ.js";
import { t as g } from "./BaseTypography.styles-D7he6cFf.js";
import { n as h } from "./normalize-spacing-DY0KSpr_.js";
const T = ({
  as: t = "span",
  color: o,
  fontFamily: r,
  size: s,
  modifier: a,
  fontWeight: n = "inherit",
  variant: m,
  truncate: p,
  spacing: i,
  children: e,
  ...c
}) => {
  const x = t;
  return /* @__PURE__ */ f.jsx(
    x,
    {
      className: j(
        g({ variant: m, color: o, size: s, modifier: a, truncate: p, fontWeight: n, fontFamily: r }),
        h(i)
      ),
      ...c,
      children: e
    }
  );
};
export {
  T
};
